import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  EcommerceWebIndustryFashion,
  EcommerceWebIndustryGrocery,
  EcommerceWebIndustryElectronics,
  EcommerceWebIndustryHealthcare,
  EcommerceWebIndustryBeauty,
  EcommerceWebIndustryEducation,
  EcommerceWebIndustryHomeDecor,
  EcommerceWebIndustrySports,
} from "../../../app-constants";

function Ecommerceindustries() {
  return (
    <section
      className="ecommerce_industries p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Expertise Across <span>eCommerce Industries</span>
            </h2>
            <p>
              At TekRevol, we offer specialized eCommerce web development
              services across top industries. Our business analysts and product
              planners use in-depth industry knowledge to refine your product
              strategy for a successful launch. From retail to healthcare, we
              have the technical prowess to make your eCommerce strategy and
              product successful.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="ecommerce_industries_main">
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {EcommerceWebIndustryFashion}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Fashion & Apparel</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {EcommerceWebIndustryGrocery}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Grocery</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {EcommerceWebIndustryElectronics}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Electronics & Gadgets</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {EcommerceWebIndustryHealthcare}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Healthcare</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {EcommerceWebIndustryBeauty}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Beauty</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {EcommerceWebIndustryEducation}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Education</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {EcommerceWebIndustryHomeDecor}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Home Decor</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {EcommerceWebIndustrySports}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Sports & Fitness</h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommerceindustries;
